import { AngleLeft, AngleRight } from "flowbite-react-icons/outline";
import PropTypes from "prop-types";

CarouselButton.propTypes = {
  direction: PropTypes.oneOf(["left", "right"]).isRequired,
  enabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
export default function CarouselButton({ direction, enabled, onClick }) {
  if (direction === "right") {
    return (
      <div className="absolute right-0 top-0 bottom-0 flex justify-center items-center mr-2 z-10">
        <button type="button" className="btn btn-circle" disabled={!enabled} onClick={onClick}>
          <AngleRight />
        </button>
      </div>
    );
  }

  return (
    <div className="absolute left-0 top-0 bottom-0 flex justify-center items-center ml-2 z-10">
      <button type="button" className="btn btn-circle" disabled={!enabled} onClick={onClick}>
        <AngleLeft />
      </button>
    </div>
  );
}
